import React, { useEffect, useState } from "react";
import {
  Card,
  List,
  Table,
  Tabs,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  message,
} from "antd";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";

const { TabPane } = Tabs;
const { Option } = Select;

const ActAndSection = (props) => {
  const [kayda, setkayda] = useState([]);
  const [kalams, setkalam] = useState([]);
  const [acts, setActs] = useState("");
  const [actsSearch, setActsSearch] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const [form] = Form.useForm();

  const data = kayda.map((item, index) => ({
    key: index,
    kayda: item.kayda,
  }));

  const filteredKalamData = kalams
    .filter(
      (item) =>
        actsSearch.trim() === "" ||
        (item.section &&
          item.section.toLowerCase().includes(actsSearch.trim().toLowerCase()))
    )
    .map((item, index) => ({
      key: index,
      kalam: item.section,
    }));

  const columns = [
    {
      title: "Sr No",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => {
        const currentPage = pagination.current || 1;
        const pageSize = pagination.pageSize || 10;
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: "कायदा",
      dataIndex: "kayda",
      key: "kayda",
    },
  ];

  const kalamColumns = [
    {
      title: "Sr No",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => {
        const currentPage = pagination.current || 1;
        const pageSize = pagination.pageSize || 10;
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: "कलम",
      dataIndex: "kalam",
      key: "kalam",
    },
  ];
  useEffect(() => {
    props.dispatch(professionalAction.getKayda());
  }, []);

  useEffect(() => {
    if (props?.professionals?.pc_kalams) {
      setkalam([...props.professionals.pc_kalams]);
    }
    if (props?.professionals?.pc_acts) {
      setkayda([...props.professionals.pc_acts]);
    }
  }, [props?.professionals?.pc_kalams, props?.professionals?.pc_acts]);

  const onkaydaChange = (value) => {
    console.log("value", value);
    setActs(value);
    setActsSearch("");
    props.dispatch(professionalAction.getKalam(value));
  };

  const submitKayda = async () => {
    let act_id;
    const actCdList = kayda.map((item) => Number(item.act_cd));

    const maxActCd = Math.max(...actCdList);
    act_id = maxActCd + 1;

    const data = {
      kayda: acts,
      act_cd: act_id,
    };
    try {
      const response = await professionalAction.saveActs(data);
      if (!response.ok) {
        const errorDetail = await response.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Voter ID with third-party service"
        );
      }
      message.success("Act submitted successfully");
      form.resetFields(["rules"]);
      setActs("");
      props.dispatch(professionalAction.getKayda());
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
    }
  };

  const onFinish = async (values) => {
    console.log("kayda", kayda);
    const selectedRule = kayda.find((rule) => rule.act_cd === values.rules);

    if (selectedRule) {
      const searchRequestData = {
        act_cd: values.rules,
        search_text: values.kalam || "",
      };

      try {
        const searchResponse = await professionalAction.searchAddedKalam(
          searchRequestData
        );
        if (!searchResponse.ok) {
          const errorDetail = await searchResponse.json();
          throw new Error(errorDetail.message || "Failed to search Kalam.");
        }

        const searchData = await searchResponse.json();

        if (Array.isArray(searchData) && searchData.length > 0) {
          message.info("Kalam already exists.");
          return;
        }

        const addRequestData = {
          act_cd: values.rules,
          section_desc: selectedRule?.kayda || "",
          section: values.kalam || "",
        };

        const addResponse = await professionalAction.saveSections(
          addRequestData
        );
        if (!addResponse.ok) {
          const errorDetail = await addResponse.json();
          throw new Error(errorDetail.message || "Failed to save the section.");
        }

        message.success("Section submitted successfully");
        props.dispatch(professionalAction.getKalam(values.rules));
      } catch (error) {
        const errorMessage = error.message || "An unexpected error occurred.";
        message.error(errorMessage);
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Act" key="1" style={{ padding: "5px" }}>
          <Row gutter={24}>
            <Col span={10}>
              <Form.Item
                name="rules"
                label="कायदा"
                rules={[{ required: true, message: "Please select a rule" }]}
              >
                <Input
                  placeholder="Please enter कायदा"
                  value={acts}
                  onChange={(e) => setActs(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Button type="primary" disabled={!acts} onClick={submitKayda}>
                Add New Kayda
              </Button>
            </Col>
          </Row>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              onChange: (page, pageSize) =>
                setPagination({ current: page, pageSize }),
            }}
          />
        </TabPane>
        <TabPane tab="Section" key="2">
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="rules"
                  label="कायदा"
                  rules={[{ required: true, message: "Please select a rule" }]}
                >
                  <Select
                    placeholder="Please select a rule"
                    onChange={onkaydaChange}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {kayda.map((res, index) => (
                      <Option key={index} value={res.act_cd}>
                        {res.kayda}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="kalam"
                  label="कलम"
                  rules={[
                    { required: true, message: "Please enter a section" },
                  ]}
                >
                  <Input placeholder="Please enter कलम" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Button type="primary" htmlType="submit">
                  Add New Kalam
                </Button>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                margin: "10px 0",
              }}
            >
              <Input
                placeholder="Search"
                style={{ width: 200, marginRight: 8 }}
                value={actsSearch}
                onChange={(e) => {
                  setActsSearch(e.target.value);
                  setPagination((p) => ({ ...p, current: 1 }));
                }}
              />
            </div>
            <Table
              columns={kalamColumns}
              dataSource={filteredKalamData}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                onChange: (page, pageSize) =>
                  setPagination({ current: page, pageSize }),
              }}
            />
          </Form>
        </TabPane>
      </Tabs>
    </>
  );
};

function mapStateToProps(state) {
  const { authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    professionals,
  };
}

const connectedActAndSection = connect(mapStateToProps)(ActAndSection);
export { connectedActAndSection as ActAndSection };
